<!-- =========================================================================================
    File Name: FeatherIcon.vue
    Description: Feather icon component. Creates feather icon based on 'icon' prop
    Component Name: FeatherIcon
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<script setup>
// import * as icons from 'vue-feather-icons'
import { computed } from 'vue'

const props = defineProps({
  icon: { type: String, required: true },
  svgClasses: { type: [String, Object, Array], default: '' },
  badge: {}
})

const IconComponent = computed(() => icons[props.icon])
</script>

<template>
  <span class="feather-icon select-none relative">
    <component
      :is="IconComponent"
      :class="svgClasses"
    />
    <span
      v-if="badge"
      class="feather-icon-badge bg-primary text-white h-5 w-5 absolute rounded-full text-xs flex items-center justify-center"
      style="top: -7px; right: -5px"
    >{{ badge }}</span>
  </span>
</template>

<style lang="scss">
@import "@/assets/scss/vuexy/components/featherIcon.scss";
</style>
